import {Select} from "antd";
import {useGetCustomerStoreServicesOrdersContext} from "../../../../../../../service-feature/useCases/get-orders/context/customer";
import {OrdersFilterOptions} from "../../../header/filter";

export function CustomerOrdersFilter() {
  const {
    state: {statusId},
    dispatch,
  } = useGetCustomerStoreServicesOrdersContext();
  return (
    <div>
      <Select
        id="services-orders-filter-select-id"
        size="large"
        style={{width: "100%"}}
        onChange={(value) =>
          dispatch({
            type: "update-status-id",
            payload: value,
          })
        }
        value={statusId}
        options={OrdersFilterOptions}
      />
    </div>
  );
}
